module.exports = __webpack_public_path__ + "static/no-results-a453430955efd4a8bdfc5d954b3465e7.png";